<template>
  <div ref="text" class="c-text" @click="$emit('on-select')">
    <div class="c-text-wrap" :class="{ 'c-active-check': active }">
      <div v-if="!!text" class="c-complete">
        <p
          v-html="text"
          :style="{
            color,
            lineHeight,
            fontSize: `${fontSize}px`,
            textAlign,
            fontFamily,
            fontStyle: fontStyle.includes('italic') ? 'italic' : '',
            fontWeight: fontStyle.includes('bold') ? 'bold' : '',
            textDecoration: fontStyle.includes('underline') ? 'underline' : '',
            letterSpacing: `${letterSpacing}px`
          }"
        ></p>
      </div>
      <div v-else class="c-init">
        <span>请添加文本内容</span>
      </div>
      <div v-show="active" class="c-corn">
        <Button shape="circle" icon="md-arrow-up" @click.stop="$emit('on-prev')" />
        <Button shape="circle" icon="md-arrow-down" @click.stop="$emit('on-next')" />
        <Button shape="circle" icon="md-trash" @click.stop="$emit('on-delete')" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'textComponent',
  props: {
    attr: {
      type: Array,
      default() {
        return []
      }
    },
    active: {
      type: Boolean,
      default() {
        return false
      }
    },
    index: {
      type: Number
    }
  },
  computed: {
    text() {
      let text = ''
      const index = this.attr.findIndex((ret) => ret.name === 'text')
      if (index > -1) text = this.attr[index].text.replace(/\n/g, '<br />')
      return text
    },
    color() {
      let color = '#333'
      const index = this.attr.findIndex((ret) => ret.name === 'color')
      if (index > -1) color = this.attr[index].color
      return color
    },
    fontSize() {
      let val = 14
      const index = this.attr.findIndex((ret) => ret.name === 'font_size')
      if (index > -1) val = this.attr[index].font_size
      return val
    },
    fontFamily() {
      let val = 'font-0'
      const index = this.attr.findIndex((ret) => ret.name === 'font_family')
      if (index > -1) val = this.attr[index].font_family
      return val
    },
    lineHeight() {
      let val = 2
      const index = this.attr.findIndex((ret) => ret.name === 'format')
      if (index > -1) {
        const { line_height } = this.attr[index].children.filter((ret) => ret.name === 'line_height').pop()
        val = line_height
      }
      return val
    },
    fontStyle() {
      let val = []
      const index = this.attr.findIndex((ret) => ret.name === 'format')
      if (index > -1) {
        const { font_style } = this.attr[index].children.filter((ret) => ret.name === 'font_style').pop()
        val = font_style
      }
      return val
    },
    letterSpacing() {
      let val = 0
      const index = this.attr.findIndex((ret) => ret.name === 'format')
      if (index > -1) {
        const { letter_spacing } = this.attr[index].children.filter((ret) => ret.name === 'letter_spacing').pop()
        val = letter_spacing
      }
      return val
    },
    textAlign() {
      let val = 'center'
      const index = this.attr.findIndex((ret) => ret.name === 'format')
      if (index > -1) {
        const { text_align } = this.attr[index].children.filter((ret) => ret.name === 'text_align').pop()
        val = text_align
      }
      return val
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.c-text {
  width: 100%;
  position: relative;

  .c-text-wrap {
    width: 375px;
    margin: 0 auto;
    box-shadow: 1px 1px 7px 1px #e8e8e8;
    position: relative;

    &.c-active-check {
      border: solid 1px #4b77ee;

      &:before {
        content: '';
        position: absolute;
        z-index: -1;
        width: 3840px;
        height: inherit;
        background-color: #e8e9eb;
        left: -1920px;
        top: -1px;
      }

      i,
      span {
        color: #4b77ee;
      }
    }

    .c-init {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      height: 66px;
      background-color: #fff;

      span {
        font-size: 14px;
        line-height: 22px;
        margin-top: 4px;
      }
    }

    .c-complete {
      width: 100%;

      // height 100%
      p {
        margin: 0;
        padding: 0;
      }
    }

    .c-corn {
      width: 32px;
      min-height: 96px;
      position: absolute;
      z-index: 4;
      top: 0px;
      right: -52px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
</style>
